import {AssessedScoresRow} from "./AssessedScoresRow"
import {OrientationReadinessChart} from "../orientation/OrientationReadinessChart"
import {EducatorOrientationFields} from "./EducatorOrientationFields"
import {ProgressCardHeader} from "./ProgressCardHeader"
import {SupportScoresRow} from "./SupportScoresRow"
import {scoreBadge} from "../../utilities/general"

export const CumulativeDetails = ({orientation, osr, nhsr, osrSubmissionStatus, nhsrSubmissionStatus}) => {
    // The latest osr represents the cumulative details

    const osrBadge = scoreBadge(osr?.osr_score?.val, osr?.osr_score?.max)
    const latestReport =
        orientation.progress_reports && orientation.progress_reports.length
            ? orientation.progress_reports.reduce((latest, current) => {
                  return new Date(current.created_at) > new Date(latest.created_at) ? current : latest
              })
            : null
    const futureStartDate = new Date() < new Date(orientation.start_date)
    const menuWeek = Number.isFinite(orientation.current_week_of_orientation)
        ? orientation.current_week_of_orientation
        : orientation.current_week_of_hire
    // /orientation-details omits latest_missing_progress_report_week, so derive the due weeks here:
    // every week in 1..menuWeek with no rated report (matches the active orientees list logic).
    const ratedWeeks = new Set(
        (orientation.progress_reports ?? []).filter((report) => report.rating_id).map((report) => report.week)
    )
    const progressReportsDue = []
    for (let week = 1; Number.isFinite(menuWeek) && week <= menuWeek; week++) {
        if (!ratedWeeks.has(week)) progressReportsDue.push(week)
    }

    return (
        <>
            <div className="card mx-10 my-6 border border-gray-400">
                <ProgressCardHeader
                    badge={osrBadge}
                    name="Progress Snapshot"
                    osr={osr}
                    osrSubmissionStatus={osrSubmissionStatus}
                    nhsrSubmissionStatus={nhsrSubmissionStatus}
                    progressReport={latestReport || null}
                    progressReportWarning={true}
                    futureStartDate={futureStartDate}
                />
                <div className="card-body px-5">
                    <EducatorOrientationFields orientation={orientation} />
                    <div className="separator my-4"></div>
                    <h3 className="w-100 my-5">Cumulative Ready for Practice Scores</h3>
                    <AssessedScoresRow osr={osr} nhsr={nhsr} />
                    <div className="separator my-4"></div>
                    <h3 className="w-100 my-5">Cumulative Domain Competency Scores</h3>
                    <div className="row row-cols-1 row-cols-lg-2 g-10 mb-8">
                        {osr &&
                            osr.categories &&
                            Object.keys(osr.categories).map((cat, index) => {
                                const score = osr.categories[cat]
                                const badge = scoreBadge(score.val, score.max)

                                return (
                                    <div className="col" key={`cdc-${index}`}>
                                        <div className="d-flex flex-column w-100 gap-5">
                                            <div className="d-flex align-items-center w-100 flex-column">
                                                <div className="d-flex justify-content-between w-100 mb-2">
                                                    <span className="fw-bold fs-5">{cat}</span>
                                                    <div className="fw-bold fs-5">{score.percent}%</div>
                                                </div>
                                                <div className="h-10px mx-3 rounded w-100 bg-secondary">
                                                    <div
                                                        className={`${badge.color} rounded h-10px`}
                                                        role="progressbar"
                                                        style={{width: `${score.percent}%`}}
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                    </div>
                    <div className="separator my-4"></div>
                    <h3 className="w-100 my-5">Cumulative NHSR Scores</h3>
                    <SupportScoresRow nhsr={nhsr} />
                    <div className="text-muted fs-8 mt-2">Casey-Fink Graduate Nurse Experience Survey &#169; 2023</div>
                </div>
            </div>
            <div className="card card-px-0 mx-10 px-4 px-md-6 border border-gray-400">
                <div className="card-header min-h-70px">
                    <h3 className="card-title fw-bold">Weekly Progress Snapshot</h3>
                </div>
                <OrientationReadinessChart orientee={orientation} />
            </div>
        </>
    )
}
